import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
import { Validators } from '@angular/forms';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import {CuentaAddComponent} from '../cuentasAddEdit/cuentasAddEdit.component';
import { modalComponent } from '../../../utils/modal/modal.component';
import {CuentaGenerarXMLComponent} from '../consultar/archivoXML/cuenta-generarXML.componen.'


@Component({
    selector: 'my-cuenta-consultar',
    styleUrls: ['cuenta-consultar.component.scss'],
    templateUrl: 'cuenta-consultar.component.html',
    providers: [generalService]
})
export class CuentaConsultarComponent implements OnInit{
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    myForm: FormGroup;
    dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
    @ViewChild('tableCuenta') tableCuenta: ElementRef;
    
    companyName = "";
    public dataReporteCuenta: any[] = [];
    public list_Rango: any[] = [];
    public list_Cuentas: any[] = [];
    public list_CuentasFilters: any[] = [];
    public list_Cuenta_Excel : any[] = [];
    public list_Cuenta_xml : any[] = [];
    public list_Nivel: any[] = [];
    public level = 0
    private readonly CONFIRM_DELETE_MSG = '¿Está seguro que desea dar de baja la Cuenta?';
  
    displayedColumns = ['acciones','NUMEROCUENTA', 'NOMBRE', 'NIVEL',  
                        'AFECTABLE', 'NATURALEZA','CODIGOSAT', 'ESTATUS',
    ];
  
    constructor(private formBuilder: FormBuilder,
                private _generalService: generalService,
                public dataService: DataService,
                public dialog: MatDialog) {
                    this.myForm = new FormGroup({});
                }
  
    ngOnInit() {
        this.buildForm();
        this.getDataFilters();
        this.consultarCuentas();
    }
    
    buildForm() {
        this.myForm = this.formBuilder.group({
            numCuentaForm: ['', Validators.pattern('^[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4}$')],
            nombreForm: [''],
            rangoForm: ['0'],
            nivelForm: ['0']
        });
    }
    
    formatNumCuenta() {
       let grupoMax = 0;
       grupoMax = ( this.level * 4) 
        let numCuenta = this.myForm.get('numCuentaForm').value.replace(/\D/g, '').substring(0, grupoMax); // Solo números, máximo N caracteres
        let formattedNumCuenta = '';
        
        for (let i = 0; i < numCuenta.length; i++) {
            if (i > 0 && i % 4 === 0) {
                formattedNumCuenta += '-';
            }
            formattedNumCuenta += numCuenta[i];
        }
        
        this.myForm.patchValue({ numCuentaForm: formattedNumCuenta });
    }
    
    
    
    getDataFilters() {
        this.list_Nivel= [];
        let metodo = 'Cuenta/getDataCuentaFilters';
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
        };
  
        this._generalService.metodoCallParams(params, metodo).subscribe(
          result => {
            const tableResult = JSON.parse(result);
            this.list_Rango = tableResult.Table; 
            this.level = tableResult.Table1[0]['LEVEL'];
            this.list_Cuentas = tableResult.Table2;
            for (let i = this.level; i >= 1; i--) {
                this.list_Nivel.push({
                    nivel: i,
                    NAME: i
                });
            }
            this.list_Nivel.reverse();// de menor a mayor

          },
          error => {  console.log(<any>error);  }
        );
        
    }

    nuevaCuenta(idCuenta){
        let level = this.level;

        const dialogRef = this.dialog.open(CuentaAddComponent, {
            disableClose: true, 
            width: '50vw',
            height: '70vh',
            maxWidth: '95vw', 
            maxHeight: '95vh', 
            panelClass: 'full-width-dialog',
            data: {
              levemax:level,
              ACCOUNT_ID:idCuenta,
              list_Cuentas:this.list_Cuentas
            } });
            this.dataService.dialogRef = dialogRef;
            dialogRef.afterClosed().subscribe((res) => {
                const tableResult = res;
                let bandera = tableResult

                if(bandera == 1){
                    this.getDataFilters();
                    this.consultarCuentas();
                }
            });
    }

    consultarCuentas(){
        let rango = 0;
        let nivel = 0
        let numeroCuenta = "";
        let nombreCuenta = "";
        rango = this.myForm.controls['rangoForm'].value;
        nivel = this.myForm.controls['nivelForm'].value;
        numeroCuenta = this.myForm.controls['numCuentaForm'].value;
        nombreCuenta = this.myForm.controls['nombreForm'].value;

        const params = {
            NAME: nombreCuenta, 
            NIVEL:nivel,
            NUMBER :numeroCuenta,
            RANGE_ACCOUNT_ID:rango,
            loacs: sessionStorage.getItem('acslo')
        };

        this._generalService.metodoCallParams(params, 'Cuenta/consultAccountFilters',true).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.list_CuentasFilters = tableResult;
                //this.listarConsulta();
                this.dataSource = new DataSourceGrid(this.list_CuentasFilters, this.paginator, this.sort);
                this.list_Cuenta_Excel =  this.list_CuentasFilters ;
                if(this.list_CuentasFilters.length <= 0){ 
                    $(".mat-row").remove(".mat-row"); 
                }
            }, (error) => {
              console.log(error as any);
        });

    }

    listarConsulta(){
         // Copiar la lista original para no modificarla directamente
         const listaOrdenada = [...this.list_CuentasFilters];

         // Ordenar por ACCOUNT_ID de menor a mayor
         //listaOrdenada.sort((a, b) => a.ACCOUNT_ID - b.ACCOUNT_ID);
 
         // Crear un conjunto para almacenar los ACCOUNT_ID que ya han sido incluidos
         const includedIds = new Set();
 
         // Lista final ordenada
         const listaFinal = [];
 
         // Iterar sobre la lista ordenada
         for (const cuenta of listaOrdenada) {
             // Verificar si el ACCOUNT_ID ya ha sido incluido
             if (!includedIds.has(cuenta.ACCOUNT_ID)) {
                 listaFinal.push(cuenta);
                 includedIds.add(cuenta.ACCOUNT_ID);
             }
             // Verificar si hay cuentas con PARENT_ACCOUNT_ID igual al ACCOUNT_ID actual
             const matchingParentAccounts = this.list_CuentasFilters.filter(c => c.PARENT_ACCOUNT_ID === cuenta.ACCOUNT_ID);
             // Ordenar las cuentas con PARENT_ACCOUNT_ID según el campo NIVEL de menor a mayor
             matchingParentAccounts.sort((a, b) => a.NIVEL - b.NIVEL);
             for (const parentAccount of matchingParentAccounts) {
                 // Si el ACCOUNT_ID del PARENT_ACCOUNT_ID no ha sido incluido, lo añadimos
                 if (!includedIds.has(parentAccount.ACCOUNT_ID)) {
                     listaFinal.push(parentAccount);
                     includedIds.add(parentAccount.ACCOUNT_ID);
                 }
             }
         }

         
         
 
         this.dataSource = new DataSourceGrid(listaFinal, this.paginator, this.sort);
            this.list_Cuenta_Excel =  listaFinal ;
         if(this.list_CuentasFilters.length <= 0){ 
             $(".mat-row").remove(".mat-row"); 
         }
    }
   
    
    eliminarCuenta(idCuenta) {
        this.dataService.modal = 'confirm';
        this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
      
        const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
        this.dataService.dialogRef = dialogModal;      
        dialogModal.afterClosed().subscribe(result => {
          if (this.dataService.guardado) {
            this.deleterow(idCuenta);
          }
        });
    }
    
    deleterow(idCuenta) {
        let bandera = 0;
        const params = { 
          loacs: sessionStorage.getItem('acslo'),
          ACCOUNT_ID:idCuenta
        };
        this._generalService.metodoCallParams(params, `Cuenta/deleteCuenta`)
        .subscribe(res => {
            const tableResult = JSON.parse(res);
            bandera = tableResult[0]['@account_children'];

            
            setTimeout(() => {
                if(bandera > 0){
                    this._generalService.toastCall("¡El registro no se puede dar de baja ya que tiene Cuentas hijas!");
                }else{
                    this._generalService.toastCall("¡El registro se dio de baja exitosamente!");
                }
                this.getDataFilters();
                this.consultarCuentas();
               
              }, 500); 

        }, error => {
          // Custom error handler
        }); 
    }

   
    // ---------------------------- Exportar a Excel-----------------
    exportarExcel() {
        //Excel
        // if (this.list_Cuenta_Excel.length > 0) {
        //     this.readyExport();            
        // }

        const dialogRef = this.dialog.open(CuentaGenerarXMLComponent, {
            disableClose: true, 
            width:'30%', 
            panelClass: 'full-width-dialog',
            data: {}
           });
           this.dataService.dialogRef = dialogRef; 
           this.dataService.dialogRef = dialogRef;
           dialogRef.afterClosed().subscribe((result) => {
               
            
        });

    }

    readyExport() {
        let tituloExcel = "Reporte de Cuenta"
        setTimeout(() => this.exportAsExcelFile(tituloExcel), 300);
    }

    public exportAsExcelFile(filename: string): void {
        
        const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableCuenta.nativeElement);

        const headersWorksheet = [ 'Número de Cuenta', 'Nombre', 'Nivel', 'Afectable', 'Naturaleza', 'Código SAT', 'Estatus'];
            for (const z in worksheet) {
                if (z[0] === '!') { 
                    continue; 
                }
                if (worksheet[z]) {                
                    if (headersWorksheet.indexOf(worksheet[z].v + '') > -1) {
                        this.wrapAndCenterCell(worksheet[z], 'header');
                    } else if (z.indexOf('L') > -1 || z.indexOf('M') > -1 || z.indexOf('N') > -1) {
                        this.wrapAndCenterCell(worksheet[z], 'decimal');
                    } else if (z.indexOf('O') > -1) {
                        this.wrapAndCenterCell(worksheet[z], 'porcentaje');
                    } else if (((z + '').indexOf('D') > -1 || z.indexOf('H') > -1 || z.indexOf('K') > -1) && worksheet[z].t === 'n' && worksheet[z].z !== 'm/d/yy') {
                        this.wrapAndCenterCell(worksheet[z], 'decimal');
                    }
                }
            }

            const workbook: XLSX.WorkBook = { Sheets: { General: worksheet}, SheetNames: ['General'] };
            const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });
            this.saveAsExcelFile(excelBuffer, filename);
    }

    private wrapAndCenterCell(cell: XLSX.CellObject, tipo: any) {
        let cellStyle;
        switch (tipo) {
            case 'header': {
                cellStyle = { font: {bold: true} };
                break;
            }
            case 'numerico': {
                cellStyle = { numFmt: '0' };
                break;
            }
            case 'decimal': {
                cellStyle = { numFmt: '$0.00;\\($0.00\\);\\-;@' };
                break;
            }
            case 'porcentaje': {
                cellStyle = { numFmt: '0.00%;\\(0.00%\\);\\-;@' };
                break;
            }
        }
        this.setCellStyle(cell, cellStyle);
    }

    private setCellStyle(cell: XLSX.CellObject, style: {}) {
        cell.s = style;
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/cuentas/consultar/cuenta-consultar.component.ts